import { SalesImport } from '../translations-types';

const translations: SalesImport = {
  title: 'Import sales lines',
  description:
    'Import your sales from Salonized (order_items CSV export). Duplicate rows are skipped automatically and every row is linked to an existing customer.',
  selectFile: 'Choose CSV file',
  importing: 'Importing…',
  resultTitle: 'Result',
  rows: 'Rows',
  imported: 'Imported',
  duplicates: 'Duplicates',
  matched: 'Linked',
  unmatched: 'Not linked',
  ambiguous: 'Ambiguous',
  noSalon: 'Select a salon first.',
  importSuccess: 'Import complete.',
  importError: 'Import failed.',
  parseError: 'Could not read the CSV file.',
  emptyFile: 'The file contains no rows.',
  history: 'Previous imports',
  date: 'Date',
  file: 'File',
  importedBy: 'By',
  noImports: 'No imports yet.',
};

export default translations;
